module.exports = __webpack_public_path__ + "img/vertical_3_5_4.60751956.png";